import browserUpdate from 'browser-update'

export const onClientEntry = () => {
  /**
   * Includes browser-update to tell users with old browsers to update.
   * We use new technology and old browsers will probably not be supported.
   */
  browserUpdate({
    required: {
      e: 17, // must set specific version since IE is included here too
      f: -2,
      o: -2,
      s: 12, // current Safari version was not up to date so had to hard code...
      c: -2,
    },
    api: 2019.11,
  })
}

export const onInitialClientRender = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari 12.0, IE)
  // Was triggered onClientEntry before, but that made image loading
  // on Safari 12.0 and iOS very flaky (sometimes lazy loading was not working).
  if (typeof window.IntersectionObserver === `undefined`) {
    import(`intersection-observer`)
    console.log(`# IntersectionObserver is polyfilled!`)
  }
}
